import type { GetPhotoSizeDto } from "src/services/generated-api";

/**
 * A photo size's base price per photo (in cents) in `currency`, or null when it
 * has none there. eur and the euro variants (eur-at) share the base price;
 * every other currency needs its own entry.
 */
export function defaultPriceInCurrency(
  ps: GetPhotoSizeDto | undefined,
  currency: string,
): number | null {
  if (!ps) return null;
  if (currency === "eur") return ps.price;
  if (ps.priceCurrencies && currency in ps.priceCurrencies) {
    return (ps.priceCurrencies as Record<string, number>)[currency];
  }
  if (currency.split("-")[0] === "eur") return ps.price;
  return null;
}
